import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteCommentNoteEntry } from '../../../api/Property/deleteCommentNoteEntry';

type DeleteCommentNoteEntryProps = {
  property_id: string;
  comment_id: string;
  note_entry_id: string;
}

export function useDeleteCommentNoteEntry() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ property_id, comment_id, note_entry_id }: DeleteCommentNoteEntryProps) =>
      deleteCommentNoteEntry(property_id, comment_id, note_entry_id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ 'getComments' ] });
    },
  });

  return mutation;
}
